// extracted by mini-css-extract-plugin
export default {"loginBlockHeader":"loginBlockHeader-V7I1I","loginBlockHeaderTitle":"loginBlockHeaderTitle-mf2AJ"};